export enum LsKeys {
  TOKEN_INFO = 'token-info',
  USER_INFO = 'user-info',
}
